import React, { MouseEventHandler, PropsWithChildren } from "react"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"

export const Tag = ({
    children,
    onRemove,
}: PropsWithChildren<{
    onRemove?: MouseEventHandler
}>) => {
    return (
        <div
            className={classNames(
                "group px-2 py-1 bg-white-100 rounded-md flex items-center gap-1 transition-colors",
                {
                    "hover:text-white cursor-pointer": !!onRemove,
                }
            )}
            onClick={(e) => {
                if (!onRemove) return
                e.stopPropagation()
                onRemove(e)
            }}
        >
            {children}
            {!!onRemove && (
                <div className="h-full w-0 opacity-0 group-hover:w-4 group-hover:opacity-100 overflow-hidden transition-[width,opacity] flex items-center justify-center">
                    <Icons.SmallIcon
                        Icon={Icons.Close}
                        className="text-red-200"
                        iconClassName="!m-0"
                    />
                </div>
            )}
        </div>
    )
}
